module.exports = __webpack_public_path__ + "static/media/HomeStoryImage5.829a3fcb.jpg";